import { z } from 'zod'
import { ref } from '@omnea-app/packages/universal/references/refKinds'
import { RequestStepTaskTypeEnum } from '@omnea-app/packages/universal/tasks/taskEnums'

export const ReviewFormTaskSchema = z.object({
  formTemplateId: ref('formTemplate'),
  type: z.literal(RequestStepTaskTypeEnum.REVIEW),
})
export type ReviewFormTask = z.infer<typeof ReviewFormTaskSchema>

export const FillInFormTaskSchema = z.object({
  formTemplateId: ref('formTemplate'),
  type: z.literal(RequestStepTaskTypeEnum.FILL_IN),
})
export type FillInFormTask = z.infer<typeof FillInFormTaskSchema>

// remoteTemplateId belongs to the e-sign provider, not to a form template.
export const EsignFillInTaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  remoteTemplateId: z.string(),
  type: z.literal(RequestStepTaskTypeEnum.ESIGN_FILL_IN),
  remoteFolderId: z.string().optional(),
  ownerEmail: z.string(),
})
export type EsignFillInTask = z.infer<typeof EsignFillInTaskSchema>

export const ExternalOperationTaskSchema = z.object({
  type: z.literal(RequestStepTaskTypeEnum.EXTERNAL_OPERATION),
  formTemplateId: ref('formTemplate').optional(),
})
export type ExternalOperationTask = z.infer<typeof ExternalOperationTaskSchema>

export const ContentGenerationTaskSchema = z.object({
  formTemplateId: ref('formTemplate'),
  type: z.literal(RequestStepTaskTypeEnum.CONTENT_GENERATION),
})
export type ContentGenerationTask = z.infer<typeof ContentGenerationTaskSchema>

export const SummaryApprovalTaskSchema = z.object({
  type: z.literal(RequestStepTaskTypeEnum.SUMMARY_APPROVAL),
  title: z.string(),
})
export type SummaryApprovalTask = z.infer<typeof SummaryApprovalTaskSchema>

export const AccountingSupplierDataSyncTaskSchema = z.object({
  type: z.literal(RequestStepTaskTypeEnum.ACCOUNTING_SUPPLIER_DATA_SYNC),
})
export type AccountingSupplierDataSyncTask = z.infer<typeof AccountingSupplierDataSyncTaskSchema>

export const FillInOrReviewTaskSchema = z.union([ReviewFormTaskSchema, FillInFormTaskSchema])
export type FillInOrReviewTask = z.infer<typeof FillInOrReviewTaskSchema>

export const RequestFormBackedTaskSchema = z.union([FillInOrReviewTaskSchema, ContentGenerationTaskSchema])
export type RequestFormBackedTask = z.infer<typeof RequestFormBackedTaskSchema>

export const EsignTaskSchema = EsignFillInTaskSchema // Add EsignReviewTask here in the future
export type EsignTask = z.infer<typeof EsignTaskSchema>

export const BlockTaskSchema = z.discriminatedUnion('type', [
  ReviewFormTaskSchema,
  FillInFormTaskSchema,
  EsignTaskSchema,
  SummaryApprovalTaskSchema,
  AccountingSupplierDataSyncTaskSchema,
  ExternalOperationTaskSchema,
  ContentGenerationTaskSchema,
])
export type BlockTask = z.infer<typeof BlockTaskSchema>
